import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=9b09b30a&scoped=true&"
import script from "./GenericCard.vue?vue&type=script&lang=js&"
export * from "./GenericCard.vue?vue&type=script&lang=js&"
import style0 from "./GenericCard.vue?vue&type=style&index=0&id=9b09b30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b09b30a",
  null
  
)

export default component.exports